import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MatterPopupComponent } from '../../matter-popup.component';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { TooltipService } from '@_services/tooltip.service';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-wills-estate',
  templateUrl: './wills-estate.component.html',
  styleUrls: ['./wills-estate.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WillsEstateComponent implements OnInit, OnDestroy {
  WillEstateForm: FormGroup;
  errorWarningData: any = {};
  MatterData: any = {};
  @Input() action: any;
  @Input() moduleType: any;
  @Input() testBool;
  @Input() toolTipList: any;
  toolTipPostion = 'above';
  APIDataSubcription: Subscription;
  APIDataSubcription_1: Subscription;
  private _unsubscribeAll$: Subject<void> = new Subject();

  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<MatterPopupComponent>,
    public datepipe: DatePipe,
    public _matDialog: MatDialog,
    private currencyPipe: CurrencyPipe,
    public behaviorService: BehaviorService,
    public confirmDialogRef: MatDialogRef<any>,
    public tooltipService: TooltipService,
  ) {
    this.initFormData();
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.APIDataSubcription = this.behaviorService.ChildTableData$.subscribe((result) => {
      if (result) {
        this.MatterData = result;
        // console.log('this.MatterData', this.MatterData?.MATTERGUID);
        this.WillEstateForm.controls['MATTERGUID'].setValue(result.MATTERGUID);
        this.WillEstateForm.controls['CONTACTGUID'].setValue(result.CONTACTGUID);
        if (
          (result.classType == 'Estate' || result.classType == 'Wills, POA & EG') &&
          result.action == 'setData'
        ) {
          this.SaveWillEstate();
        } else if (
          (result.classType == 'Estate' || result.classType == 'Wills, POA & EG') &&
          result.action == 'deleteData'
        ) {
          this.DeleteWillEstate();
        }
      }
    });

    if (this.action === 'edit') {
      this.mapWillEstateDataToField();
    }

    // clear additional details data on click "Cancel" in Prompt Popup while duplicating matter
    this.behaviorService.additionalFieldsValues$.subscribe((data) => {
      if (data == true) {
        this.mapWillEstateDataToField();
      }
    });
    this.setTooltipData();
  }

  async setTooltipData() {
    let TooltipData = JSON.parse(localStorage.getItem('FieldTooltipData'));
    if (TooltipData && TooltipData['estate']) {
      this.toolTipList = TooltipData['estate'];
    } else {
      this.tooltipService.saveToolTipData('estate').subscribe({
        next: (data) => {
          this.toolTipList = data;
        },
        error: (err) => {
          console.error('Tooltip fetch failed:', err);
          this.toastr.error(err);
          this.toolTipList = [];
        },
      });
    }
  }

  /**
   * This function is used to get the map will estate data value
   */
  mapWillEstateDataToField() {
    if (this.action === 'edit' || this.action === 'duplicate') {
      this.APIDataSubcription_1 = this._mainAPiServiceService
        .getSetData(
          { Action: 'GetData', Filters: { MATTERGUID: this.MatterData.MATTERGUID } },
          'estate',
        )
        .subscribe((response) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            let MatterWillEstateData = response.DATA.RECORDS[0];
            // this.toolTipList = response.DATA.FIELDTIPS;
            if (MatterWillEstateData) {
              this.WillEstateForm.patchValue({
                // MATTERGUID: MatterWillEstateData.MATTERGUID,
                CONTACTGUID: MatterWillEstateData.CONTACTGUID,
                ESTATEGUID: MatterWillEstateData.ESTATEGUID,
                LETTERSOFENTITLEMENT: MatterWillEstateData.LETTERSOFENTITLEMENT,
                AGEATDEATH: MatterWillEstateData.AGEATDEATH,
                DATEOFDEATH: MatterWillEstateData.DATEOFDEATH,
                PLACEOFDEATH: MatterWillEstateData.PLACEOFDEATH,
                NAMEONDEATHCERTIFICATE: MatterWillEstateData.NAMEONDEATHCERTIFICATE,
                ADDRESSOFDECEASED: MatterWillEstateData.ADDRESSOFDECEASED,
                TOTALASSETS: MatterWillEstateData.TOTALASSETS,
                TOTALLIABILITIES: MatterWillEstateData.TOTALLIABILITIES,
                ESTATENETVALUE: MatterWillEstateData.ESTATENETVALUE,
                BASISOFGRANT: MatterWillEstateData.BASISOFGRANT,
                PROBATEGRANTNO: MatterWillEstateData.PROBATEGRANTNO,
                PROBATEGRANTEDTO: MatterWillEstateData.PROBATEGRANTEDTO,
                DATEOFGRANTOFREP: MatterWillEstateData.DATEOFGRANTOFREP,
                PUBLISHEDIN: MatterWillEstateData.PUBLISHEDIN,
                PUBLISHEDDATE: MatterWillEstateData.PUBLISHEDDATE,
                DATEOFESTATETAXRETURN: MatterWillEstateData.DATEOFESTATETAXRETURN,
                ESTATETAXRETURNCOMPLETEDDATE: MatterWillEstateData.ESTATETAXRETURNCOMPLETEDDATE,
                ESTATETAXRETURNSTATUS: MatterWillEstateData.ESTATETAXRETURNSTATUS,
                DATEOFDISTRIBUTIONNOTICE: MatterWillEstateData.DATEOFDISTRIBUTIONNOTICE,
                DATEOFWILL: MatterWillEstateData.DATEOFWILL,
                PAGESINWILL: MatterWillEstateData.PAGESINWILL,
                NAMEINWILL: MatterWillEstateData.NAMEINWILL,
                MARRIEDAFTERWILL: MatterWillEstateData.MARRIEDAFTERWILL,
                MARRIEDAFTERWILLTOWHOM: MatterWillEstateData.MARRIEDAFTERWILLTOWHOM,
                DATEOFMARRIAGEAFTERWILL: MatterWillEstateData.DATEOFMARRIAGEAFTERWILL,
                NUMBEROFCODICILS: MatterWillEstateData.NUMBEROFCODICILS,
                DATEOFCODICILS: MatterWillEstateData.DATEOFCODICILS,
                WITNESS1TOCODICIL: MatterWillEstateData.WITNESS1TOCODICIL,
                WITNESS2TOCODICIL: MatterWillEstateData.WITNESS2TOCODICIL,
              });
              if (MatterWillEstateData.DATEOFGRANTOFREP) {
                this.CommanDateSetter(MatterWillEstateData.DATEOFGRANTOFREP, 'DATEOFGRANTOFREP');
              }
              if (MatterWillEstateData.DATEOFDEATH) {
                this.CommanDateSetter(MatterWillEstateData.DATEOFDEATH, 'DATEOFDEATH');
              }
              if (MatterWillEstateData.PUBLISHEDDATE) {
                this.CommanDateSetter(MatterWillEstateData.PUBLISHEDDATE, 'PUBLISHEDDATE');
              }
              if (MatterWillEstateData.DATEOFESTATETAXRETURN) {
                this.CommanDateSetter(
                  MatterWillEstateData.DATEOFESTATETAXRETURN,
                  'DATEOFESTATETAXRETURN',
                );
              }
              if (MatterWillEstateData.ESTATETAXRETURNCOMPLETEDDATE) {
                this.CommanDateSetter(
                  MatterWillEstateData.ESTATETAXRETURNCOMPLETEDDATE,
                  'ESTATETAXRETURNCOMPLETEDDATE',
                );
              }
              if (MatterWillEstateData.DATEOFDISTRIBUTIONNOTICE) {
                this.CommanDateSetter(
                  MatterWillEstateData.DATEOFDISTRIBUTIONNOTICE,
                  'DATEOFDISTRIBUTIONNOTICE',
                );
              }
              if (MatterWillEstateData.DATEOFWILL) {
                this.CommanDateSetter(MatterWillEstateData.DATEOFWILL, 'DATEOFWILL');
              }
              if (MatterWillEstateData.DATEOFMARRIAGEAFTERWILL) {
                this.CommanDateSetter(
                  MatterWillEstateData.DATEOFMARRIAGEAFTERWILL,
                  'DATEOFMARRIAGEAFTERWILL',
                );
              }
            }
          }
        });
    }
  }

  /**
   * this function is used to save the will esate
   */
  SaveWillEstate() {
    this.behaviorService.setMatterLoding(true);
    let formData: any = this.WillEstateForm.value;
    if (this.action === 'duplicate') {
      delete formData.ESTATEGUID;
    }
    delete formData.DATEOFGRANTOFREPTEXT;
    delete formData.DATEOFDEATHTEXT;
    delete formData.PUBLISHEDDATETEXT;
    delete formData.DATEOFDISTRIBUTIONNOTICETEXT;
    delete formData.DATEOFWILLTEXT;
    delete formData.DATEOFESTATETAXRETURNTEXT;
    delete formData.ESTATETAXRETURNCOMPLETEDDATETEXT;
    delete formData.DATEOFMARRIAGEAFTERWILLTEXT;
    const formAction = formData.ESTATEGUID ? 'Update' : 'Insert';
    const DebtRecoveryData: any = { Action: formAction, VALIDATEONLY: true, Data: formData };
    this._mainAPiServiceService.getSetData(DebtRecoveryData, 'estate').subscribe(
      (res) => {
        if (res.CODE == 200 && res.STATUS == 'success') {
          this.checkValidation(res.DATA.VALIDATIONS, DebtRecoveryData);
        } else if (res.CODE == 451 && res.STATUS == 'warning') {
          this.checkValidation(res.DATA.VALIDATIONS, DebtRecoveryData);
        } else if (res.CODE == 450 && res.STATUS == 'error') {
          this.checkValidation(res.DATA.VALIDATIONS, DebtRecoveryData);
        } else if (res.MESSAGE == 'Not logged in') {
          this.dialogRef.close(false);
        }
      },
      (error) => {
        this.behaviorService.setMatterLoding(false);
        this.toastr.error(error);
      },
    );
  }

  /**
   * This function is used to check the validation data vaue
   */
  checkValidation(bodyData: any, details: any) {
    let errorData: any = [];
    let warningData: any = [];
    let tempError: any = [];
    let tempWarning: any = [];
    bodyData.forEach(function (value) {
      if (value.VALUEVALID == 'No') {
        errorData.push(value.ERRORDESCRIPTION);
        tempError[value.FIELDNAME] = value;
      } else if (value.VALUEVALID == 'Warning') {
        tempWarning[value.FIELDNAME] = value;
        warningData.push(value.ERRORDESCRIPTION);
      }
    });
    this.errorWarningData = { Error: tempError, warning: tempWarning };
    if (Object.keys(errorData).length != 0) {
      this.toastr.error(errorData);
      this.behaviorService.setMatterLoding(false);
    } else if (Object.keys(warningData).length != 0) {
      this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
        disableClose: true,
        width: DIALOG_WIDTH.FULL,
        data: warningData,
      });
      this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to Save?';
      this.confirmDialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.SaveWillEstateAfterVAlidation(details);
        }
        this.behaviorService.setMatterLoding(false);
        this.confirmDialogRef = null;
      });
    } else if (Object.keys(warningData).length == 0 && Object.keys(errorData).length == 0) {
      this.SaveWillEstateAfterVAlidation(details);
    }
  }

  /**
   * This function ia used to Save the will estate After validation data value
   */
  SaveWillEstateAfterVAlidation(data: any) {
    data.VALIDATEONLY = false;
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this._mainAPiServiceService.getSetData(data, 'estate').subscribe(
      (response) => {
        if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
          this.behaviorService.setChildTableData(false);
          this.behaviorService.setMatterLoding(false);
          this.dialogRef.close(true);
        } else if (response.CODE == 451 && response.STATUS == 'warning') {
          this.toastr.warning(response.MESSAGE);
          this.behaviorService.setMatterLoding(false);
        } else if (response.CODE == 450 && response.STATUS == 'error') {
          this.toastr.error(response.MESSAGE);
          this.behaviorService.setMatterLoding(false);
        } else if (response.MESSAGE == 'Not logged in') {
          this.dialogRef.close(false);
        }
      },
      (error) => {
        this.behaviorService.setMatterLoding(false);
        this.toastr.error(error);
      },
    );
  }

  /**
   * This function is used to get the CommanData Setter
   */
  CommanDateSetter(val, Field) {
    let SplitedDate = val.split('/');
    this.WillEstateForm.controls[Field + 'TEXT'].setValue(
      new Date(SplitedDate[1] + '/' + SplitedDate[0] + '/' + SplitedDate[2]),
    );
  }

  /**
   * This function is used to initiate the Form value
   */
  initFormData() {
    this.WillEstateForm = this._formBuilder.group({
      MATTERGUID: [''],
      ESTATEGUID: [''],
      CONTACTGUID: [''],
      LETTERSOFENTITLEMENT: [''],
      AGEATDEATH: [''],
      DATEOFDEATH: [''],
      DATEOFDEATHTEXT: [''],
      PLACEOFDEATH: [''],
      NAMEONDEATHCERTIFICATE: [''],
      ADDRESSOFDECEASED: [''],
      TOTALASSETS: ['', { updateOn: 'blur' }],
      TOTALLIABILITIES: ['', { updateOn: 'blur' }],
      ESTATENETVALUE: ['', { updateOn: 'blur' }],
      BASISOFGRANT: [''],
      PROBATEGRANTNO: [''],
      PROBATEGRANTEDTO: [''],
      DATEOFGRANTOFREP: [''],
      DATEOFGRANTOFREPTEXT: [''],
      PUBLISHEDIN: [''],
      PUBLISHEDDATE: [''],
      PUBLISHEDDATETEXT: [''],
      DATEOFDISTRIBUTIONNOTICE: [''],
      DATEOFDISTRIBUTIONNOTICETEXT: [''],

      DATEOFWILL: [''],
      DATEOFWILLTEXT: [''],
      PAGESINWILL: [''],
      NAMEINWILL: [''],
      MARRIEDAFTERWILL: [''],
      MARRIEDAFTERWILLTOWHOM: [''],
      DATEOFMARRIAGEAFTERWILL: [''],
      DATEOFMARRIAGEAFTERWILLTEXT: [''],
      NUMBEROFCODICILS: [''],
      DATEOFCODICILS: [''],
      WITNESS1TOCODICIL: [''],
      WITNESS2TOCODICIL: [''],
      DATEOFESTATETAXRETURN: [''],
      ESTATETAXRETURNCOMPLETEDDATE: [''],
      ESTATETAXRETURNSTATUS: [''],
      DATEOFESTATETAXRETURNTEXT: [''],
      ESTATETAXRETURNCOMPLETEDDATETEXT: [''],
    });
  }

  /**
   * This function is used to DELETE will estate.
   */
  DeleteWillEstate() {
    this._mainAPiServiceService
      .getSetData(
        { Action: 'GetData', Filters: { MATTERGUID: this.MatterData.MATTERGUID } },
        'estate',
      )
      .subscribe((response) => {
        if (response.CODE == 200 && response.STATUS == 'success') {
          let MatterWillEstateData = response.DATA.RECORDS[0];
          // this.toolTipList = response.DATA.FIELDTIPS;
          let postData = {
            FormAction: 'Delete',
            Data: { ESTATEGUID: MatterWillEstateData.ESTATEGUID },
          };
          this._mainAPiServiceService.getSetData(postData, 'estate').subscribe((res) => {
            if (res.STATUS == 'success' && res.CODE == 200) {
              // this.toastr.success('Deleted successfully');
            } else {
              let Massge: any = res.DATA.VALIDATIONS[0]
                ? res.DATA.VALIDATIONS[0]['ERRORDESCRIPTION']
                : res.MESSAGE;
              this.toastr.error(Massge);
            }
          });
        }
      });
  }

  /**
   * This function is used to get the updated text
   */
  myFunction(event: any) {
    // var copyText: any = document.getElementById("myInput");
    // copyText.select();
    // copyText.setSelectionRange(0,9999);
    // navigator.clipboard.writeText(copyText.value)
    // var copyText: any = document.getElementById("myInput");
    // event.select();
    // event.setSelectionRange(0,9999);
    navigator.clipboard.writeText(event);
  }

  ngOnDestroy(): void {
    this.APIDataSubcription?.unsubscribe();
    this.APIDataSubcription_1?.unsubscribe();
  }
}
